export default __webpack_public_path__ + "static/media/MICROSOFT_CORTANA.a30d2784.png";